import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, QueryList, ViewChildren } from '@angular/core';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IMessageInbox } from 'src/app/models/IMessagetype';
import { Router, ActivatedRoute } from '@angular/router';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ppbook-appointment',
  templateUrl: './ppbook-appointment.component.html',
  styleUrls: ['./ppbook-appointment.component.css']
})
export class PPBookAppointmentComponent implements OnInit {
  PPBookAppointment: FormGroup;
  public IMessagebookApp: IMessageInbox;
  patientId: number;
  dPatId: number;
  reasonForVisit: number;
  fullName: string;
  locationName: string;
  preferDate: any;
  preferredValue: string;
  checkpreferredValue: string;
  providerName: string;
  providerId: string;
  locationId: number;
  status: string;
  Linkid: number;
  PatRequestId: number;
  beforeTime: string;
  afterTime: string;
  inBetweenFrom: string;
  inBetweenTo: string;
  isMedicalEmergency: string;
  isTelemedicineVisit: string;
  preferredDays: string;
  disabledRejectButton: boolean = false;
  disabledSubmitButton: boolean = false;
  disabledcheckbox: boolean = false;
  anytimehideshow: boolean = false;
  beforetimehideshow: boolean = false;
  aftertimehideshow: boolean = false;
  betweentimehideshow: boolean = false;
  constructor(private sharedService: SharedService, private route: ActivatedRoute,
    private fb: FormBuilder, private toastr: ToastrService, public datepipe: DatePipe, private router: Router, private crypto: AESAlgorithm, private bannerService: PatientBannerService) {

  }
  isDisableDemographicsbutton: boolean = false;
  ngOnInit() {
    this.Linkid = Number(this.route.snapshot.paramMap.get('linkid'));
    this.PPBookAppointment = this.fb.group({
      statustext: ['', Validators.required],
      rejectReason: ['']
    });
    this.getBookingDetails();
  }

  // changeCheck(event) {
  //   if (event.checked == true) {
  //     this.IsStatusReject = true;
  //     this.IsStatusPending = false;
  //   } else {
  //     this.IsStatusReject = false;
  //     this.IsStatusPending = true;
  //   }
  // }

  // selected: string;
  // onselectionChange(event) {
  //   this.selected = event.target.value;
  //   if (this.selected == "Rejected" || this.selected == "Cancelled") {
  //     this.IsStatusReject = true;
  //     this.IsStatusPending = false;
  //   } else {
  //     this.IsStatusReject = false;
  //     this.IsStatusPending = true;
  //   }
  // }
  newdate: any; addDays: string;
  hideRejectbutton: boolean = true;
  getBookingDetails() {
    ;
    this.sharedService.getbookAppointmentDetails(this.Linkid).subscribe(data => {

      if (data != undefined && data != null) {
        this.IMessagebookApp = data;
        this.newdate = this.IMessagebookApp.preferDate;
        //  var datePipe=new DatePipe("en-US");
        // var currDate: any =datePipe.transform(moment(this.IMessagebookApp[0].preferDate).toDate(),'MM/dd/yyyy');
        // var currDate = this.datepipe.transform(this.IMessagebookApp[0].preferDate, 'yyyy-MM-dd');
        var currDate = this.transform(this.IMessagebookApp.preferDate)
        this.patientId = this.IMessagebookApp.patientId;
        this.dPatId = this.IMessagebookApp.dPatId;
        this.locationName = this.IMessagebookApp.locationName;
        this.preferDate = currDate;
        this.checkpreferredValue = this.IMessagebookApp.preferredValue;
        this.reasonForVisit = this.IMessagebookApp.reasonForVisit;
        this.fullName = this.IMessagebookApp.fullName;
        this.providerName = this.IMessagebookApp.providerName;
        this.status = this.IMessagebookApp.status;
        this.locationId = this.IMessagebookApp.locationId;
        this.providerId = this.IMessagebookApp.providerId;
        this.prefdate = this.IMessagebookApp.preferDate;
        this.PatRequestId = this.IMessagebookApp.requestId;
        if (this.checkpreferredValue == "AnyTime") {
          this.anytimehideshow = true;
          this.beforetimehideshow = false;
          this.aftertimehideshow = false;
          this.betweentimehideshow = false;
          this.preferredValue = this.IMessagebookApp.preferredValue;
        } else if (this.checkpreferredValue == "BeforeTime") {
          this.anytimehideshow = false;
          this.beforetimehideshow = true;
          this.aftertimehideshow = false;
          this.betweentimehideshow = false;
          this.beforeTime = this.IMessagebookApp.beforeTime;
        } else if (this.checkpreferredValue == "AfterTime") {
          this.anytimehideshow = false;
          this.beforetimehideshow = false;
          this.aftertimehideshow = true;
          this.betweentimehideshow = false;
          this.afterTime = this.IMessagebookApp.afterTime;
        } else if (this.checkpreferredValue == "InBetweenTime") {
          this.anytimehideshow = false;
          this.beforetimehideshow = false;
          this.aftertimehideshow = false;
          this.betweentimehideshow = true;
          this.inBetweenFrom = this.IMessagebookApp.inBetweenFrom + " -" + this.IMessagebookApp.inBetweenTo;
        }

        const prefereddaysSplit = this.IMessagebookApp.preferredDays.split(',');
        this.addDays = '';
        prefereddaysSplit.forEach(x => {
          var addDays = '';
          switch (x) {
            case "1":
              this.addDays += "Monday" + ', ';
              break;
            case "2":
              this.addDays += "Tuesday" + ', ';
              break;
            case "3":
              this.addDays += "Wednesday" + ', ';
              break;
            case "4":
              this.addDays += "Thursday" + ', ';
              break;
            case "5":
              this.addDays += "Friday" + ', ';
              break;
            case "6":
              this.addDays += "Saturday" + ', ';
              break;

          }
          return this.addDays;
        });
        this.addDays = this.addDays.substring(0, this.addDays.length - 2).trim() + '' + ".";
        this.preferredDays = this.addDays;
        if (this.IMessagebookApp.isMedicalEmergency == true) {
          this.isMedicalEmergency = "Yes";
        } else {
          this.isMedicalEmergency = "No"
        }
        if (this.IMessagebookApp.isTelemedicineVisit == true) {
          this.isTelemedicineVisit = "Yes";
        } else {
          this.isTelemedicineVisit = "No"
        }

        if (this.status == "Pending") {
          this.disabledSubmitButton = true;
          this.disabledRejectButton = false;
        } else {
          if (this.IMessagebookApp.status === 'Completed') {
            this.hideRejectbutton = false;
            this.patientId = Number(this.patientId);
            this.PPBookAppointment.patchValue({
              rejectReason: false
            })
          } else {
            // this.hideRejectbutton = true;

          }
          if (this.IMessagebookApp.comments == null || this.IMessagebookApp.comments == "") {
            this.isDisableRejectReason = false;
            this.isDisableDemographicsbutton = false;
          } else {
            this.hideRejectbutton = false;
            this.disabledSubmitButton = false;
            this.disabledRejectButton = false;
            this.isVisableRejectreason = true;
            this.disabledcheckbox = true;
            this.PPBookAppointment.patchValue({
              statustext: this.IMessagebookApp.comments,
              rejectReason: true
            });
            this.isVisableRejectreason = true;
            this.isDisableRejectReason = true;
            this.isDisableDemographicsbutton = true;
          }
        }
      } else {
        this.disabledSubmitButton = false;
        this.disabledRejectButton = false;
        this.disabledcheckbox = true;
        this.isDisableDemographicsbutton = true;
      }
    })
  }
  prefdate: any;
  OnSubmit() {
    ;
    if (this.Linkid != undefined || this.Linkid != null) {
      CommonComponents.patientId = this.patientId;
      CommonComponents.patientName = this.fullName;
      this.bannerService.toggle(this.patientId);
      sessionStorage.setItem("patientId", this.patientId.toString());
      sessionStorage.setItem("patientName", this.fullName);
      // sessionStorage.setItem("LocationId", this.locationId.toString());
      sessionStorage.removeItem("appDate");
      sessionStorage.removeItem("locationId");
      //sessionStorage.setItem("providerId", this.providerId);
      this.prefdate = this.datepipe.transform(this.newdate, 'yyyy-MM-dd');
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      // this.prefdate = this.datepipe.transform(this.newdate + " ", 'yyyy-dd-MM hh:mm:ss a', 'locale');
      // alert(this.newdate);
      this.router.navigateByUrl('/NewAppointment?RequestFrom=' + encodeURIComponent(this.crypto.urlParmeterEncoder('Portal')) +
        '&providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.providerId))
        + '&appDate=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.prefdate))
        + '&PPReqId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.PatRequestId))
        + '&PPLocId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.locationId)));
    }
  }

  onClick_ReasonForReject() {
    ;
    if (this.Linkid != undefined || this.Linkid != null) {
      var commenttext = this.PPBookAppointment.value.statustext;
      if (commenttext == "") {
        this.toastr.warning("Please enter the comments");
        return false;
      }
      this.sharedService.OnCancelBooking(this.Linkid, 'Rejected', commenttext).subscribe(
        (data: any) => {
          this.toastr.success(data);
          //this.getBookingDetails();
          //this.router.navigate(['messageInbox']);
          this.router.navigate(['tasksandmessages/', 'BackToMessages']);
        },
        (err: any) => {
          console.log(err);
        });
    }
  }


  transform(value: any): Date {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }

  onClick_backToMessages() {
    //this.router.navigate(['messageInbox']);
    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
  }

  isVisableRejectreason: boolean = false;
  isDisableRejectReason: boolean = false;
  changeReasonforReject(event: any) {
    ;
    if (event.target.checked) {
      this.disabledRejectButton = true;
      this.disabledSubmitButton = false;
      this.isVisableRejectreason = true;

      this.isDisableDemographicsbutton = true;

    }
    else {
      this.PPBookAppointment.patchValue({
        statustext: ''
      })

      {
        this.disabledRejectButton = false;
        this.disabledSubmitButton = true;
        this.isVisableRejectreason = false;

        this.isDisableDemographicsbutton = false;
        this.PPBookAppointment.patchValue({
          rejectReason: false
        })
      }
    }
  }
}
